import { Popover } from '@mui/material';
export interface IPopover {
    id: string|undefined;
    open: boolean;
    anchorEl:any;
    bodyContent?: React.ReactNode;
    handleClose: () => void;
    className?: string;
}
const CommonPopover =(props:IPopover)=>{
const {id,open,anchorEl,handleClose,bodyContent,className}=props;
const onClose = () =>{
    handleClose();
}
return (
    <>
        <Popover 
             id={id}
             open={open}
             anchorEl={anchorEl}
             onClose={onClose}
             className={className}
             anchorOrigin={{
               vertical: 'bottom',
               horizontal: 'left',
             }}
            >
            {bodyContent}
        </Popover>    

    </>
)
}
export default CommonPopover